export default __webpack_public_path__ + "static/media/loser.a116b5c6.png";